import { render, staticRenderFns } from "./resultunit-calculation-premium.vue?vue&type=template&id=c91086ca&scoped=true"
import script from "./resultunit-calculation-premium.vue?vue&type=script&lang=js"
export * from "./resultunit-calculation-premium.vue?vue&type=script&lang=js"
import style0 from "./resultunit-calculation-premium.vue?vue&type=style&index=0&id=c91086ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91086ca",
  null
  
)

export default component.exports